module.exports = __webpack_public_path__ + "img/img-1.2b2874be.jpg";